// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VoiceOrdersList_voice-orders-list__item__-iSQ3:not(:last-child) {
  margin-bottom: 5rem;
}

.VoiceOrdersList_voice-orders-list__item-id-wrapper__8dIf1 {
  color: var(--primary-color);
  font-size: var(--text-lg);
  margin-bottom: 4rem;
}

.VoiceOrdersList_voice-orders-list__item-id-text__pxK4q {
  font-weight: 700;
}

.VoiceOrdersList_voice-orders-list__item-id__yRfZx {
  font-weight: 600;
}

.VoiceOrdersList_voice-orders-list__item-audio-wrapper__WM8eO {
  max-width: 61rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/PreviousOrders/VoiceOrders/VoiceOrdersList/VoiceOrdersList.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".voice-orders-list__item:not(:last-child) {\n  margin-bottom: 5rem;\n}\n\n.voice-orders-list__item-id-wrapper {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  margin-bottom: 4rem;\n}\n\n.voice-orders-list__item-id-text {\n  font-weight: 700;\n}\n\n.voice-orders-list__item-id {\n  font-weight: 600;\n}\n\n.voice-orders-list__item-audio-wrapper {\n  max-width: 61rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"voice-orders-list__item": `VoiceOrdersList_voice-orders-list__item__-iSQ3`,
	"voice-orders-list__item-id-wrapper": `VoiceOrdersList_voice-orders-list__item-id-wrapper__8dIf1`,
	"voice-orders-list__item-id-text": `VoiceOrdersList_voice-orders-list__item-id-text__pxK4q`,
	"voice-orders-list__item-id": `VoiceOrdersList_voice-orders-list__item-id__yRfZx`,
	"voice-orders-list__item-audio-wrapper": `VoiceOrdersList_voice-orders-list__item-audio-wrapper__WM8eO`
};
export default ___CSS_LOADER_EXPORT___;
